// src/components/Cart.js

import React, { useContext, useState, useEffect } from 'react';
import { CartContext } from '../contexts/CartContext';
import ConfirmReserveModal from './ConfirmReserveModal';
import axios from 'axios'; 
import './Cart.css';

const Cart = () => {
  const API_URL      = process.env.REACT_APP_API_URL      || 'https://www.nualily.es';
  const WHATSAPP_ENV = process.env.REACT_APP_WHATSAPP_NUM || '';  
  

  const { cartItems, removeFromCart, updateCartItemQuantity, clearCart } = useContext(CartContext);
  const [phoneNumber, setPhoneNumber] = useState(WHATSAPP_ENV);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userName, setUserName] = useState('');
  const [userTown, setUserTown] = useState('');


  useEffect(() => {
    const name = localStorage.getItem('userName');
    const town = localStorage.getItem('userTown');
    if (name && town) {
      setUserName(name);
      setUserTown(town);

        console.log('[DEBUG] phoneNumber inicial:', phoneNumber);   // <-- quítalo después

    }

    const fetchWhatsappNumber = async () => {
      if (phoneNumber) return;            // ya lo teníamos por env
      try {
        const { data } = await axios.get(`${API_URL}/api/config/public`);
        if (data?.whatsapp) setPhoneNumber(data.whatsapp);
        else console.warn('WhatsApp no configurado en la API.');
      } catch (err) {
        console.error('Error cargando WhatsApp:', err);
      }
    };
    fetchWhatsappNumber();
  }, [phoneNumber]);
  

  

  const totalPrice = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  const formatPriceToEuros = (price) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };

  const handleReserve = () => {
    if (cartItems.length === 0) {
      alert('Tu carrito está vacío.');
      return;
    }
    setIsModalOpen(true);
  };

  const confirmReserve = () => {
    try {

 
      
    
   
       /* ✅ Permite + prefijo y 6-15 dígitos */
       const isValidPhoneNumber = n => /^\+?\d{6,15}$/.test((n ?? '').trim());


      if (!isValidPhoneNumber(phoneNumber)) {
       
        console.error('Número de WhatsApp no válido.');
        alert('El número de WhatsApp configurado es inválido.');
        return;
      }

      if (!phoneNumber) {
        console.error('Número de WhatsApp no definido en las variables de entorno.');
        alert('Error en la configuración del sistema.');
        return;
      }

      let message = `Hola, soy ${userName} de ${userTown}, me gustaría reservar los siguientes productos:\n\n`;

      cartItems.forEach(item => {
        const itemTotal = item.price * item.quantity;
        message += `• *${item.name}*\n  *Cantidad:* ${item.quantity}\n  *Subtotal:* ${formatPriceToEuros(itemTotal)}\n\n`;
      });

      const formattedTotalPrice = formatPriceToEuros(totalPrice);
      message += `*Total:* ${formattedTotalPrice}\n\nGracias.`;

      const encodedMessage = encodeURIComponent(message);
      const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
      window.open(whatsappURL, '_blank');

      clearCart();
      setIsModalOpen(false);
    } catch (error) {
      console.error('Error al abrir WhatsApp:', error);
      alert('Ocurrió un error al intentar reservar. Por favor, intenta de nuevo.');
    }
  };

  const cancelReserve = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="cart-container main-content">
      <h1 className='home-title'>Carrito de Compras</h1>

      {cartItems.length === 0 ? (
        <p>Tu carrito está vacío.</p>
      ) : (
        <>
          <ul className="cart-items-list">
            {cartItems.map((item) => (
              <li key={item._id} className="cart-item">
                {/* Mostrar imagen o video, con verificación en el campo `media` */}
                {item.media && item.media.length > 0 ? (
                  item.media[0].endsWith('.mp4') ? (
                    <video
                      src={item.media[0]}
                      className="cart-item-image"
                      controls
                      muted
                    />
                  ) : (
                    <img
                      src={item.media[0]}
                      alt={item.name}
                      className="cart-item-image"
                    />
                  )
                ) : (
                  <img src="/default-image.jpg" alt="Imagen predeterminada" className="cart-item-image" />
                )}
                <div className="cart-item-details">
                  <h2>{item.name}</h2>
                  <div className="quantity-selector">
                    <label htmlFor={`cart-quantity-${item._id}`}>Cantidad:</label>
                    <input
                      type="number"
                      id={`cart-quantity-${item._id}`}
                      min="1"
                      max={item.stock}
                      value={item.quantity}
                      onChange={(e) =>
                        updateCartItemQuantity(
                          item._id,
                          Math.max(1, Math.min(parseInt(e.target.value), item.stock))
                        )
                      }
                    />
                  </div>
                  <p>Precio Unitario: {formatPriceToEuros(item.price)}</p>
                  <p>Subtotal: {formatPriceToEuros(item.price * item.quantity)}</p>
                  <button
                    className="remove-item-button"
                    onClick={() => removeFromCart(item._id)}
                  >
                    Eliminar
                  </button>
                </div>
              </li>
            ))}
          </ul>

          <div className="cart-summary">
            <h3>Total: {formatPriceToEuros(totalPrice)}</h3>
            <button className="reserve-button" onClick={handleReserve}>
              Reservar
            </button>
          </div>

          <ConfirmReserveModal
            isOpen={isModalOpen}
            onConfirm={confirmReserve}
            onCancel={cancelReserve}
            cartItems={cartItems}
          />
        </>
      )}
    </div>
  );
};

export default Cart;
